import { traverseComponents } from './formSchemaUtils';

const hasAccommodationData = (row) =>
  Boolean(row && (row.checkInDate || row.checkOutDate || row.specialRequest));

/**
 * Travel and Accommodation share person_data.dataGrid and pair rows by position,
 * so a Travel-only row shows up as a blank Accommodation row. Drop only the
 * trailing rows with no accommodation data: removing a blank row in the middle
 * would shift the positional pairing and save dates into the wrong row.
 * Pass the participant's own rows (guest rows already removed).
 */
export const dropTrailingBlankAccommodationRows = (ownRows) => {
  let end = ownRows.length;
  while (end > 0 && !hasAccommodationData(ownRows[end - 1])) end -= 1;
  const kept = ownRows.slice(0, end);
  if (ownRows.knownCaddies !== undefined) kept.knownCaddies = ownRows.knownCaddies;
  return kept;
};

/**
 * The Accommodation form's data grid ships a default blank row, so a participant with
 * no accommodation sees an empty row before pressing Add New. Start it empty instead.
 */
export const startAccommodationGridEmpty = (components) => {
  traverseComponents(components, (comp) => {
    if (comp.key !== 'accomodation' || !Array.isArray(comp.components)) return;
    traverseComponents(comp.components, (child) => {
      if ((child.type || '').toLowerCase() !== 'datagrid') return;
      child.initEmpty = true;
      child.defaultValue = [];
    });
  });
};
